import { UNSTABLE_ToastQueue as ToastQueue } from 'react-aria-components';

/**
 * Interface for toast content that matches our existing API
 */
export interface ToastContent {
  title: string;
  description?: string;
  variant?: 'success' | 'error' | 'info' | 'warning';
  action?: {
    label: string;
    onPress: () => void;
  };
}

/**
 * Global toast queue instance
 */
export const toastQueue = new ToastQueue<ToastContent>({
  maxVisibleToasts: 5,
});
